import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TrunkNoticesComponent} from "./trunk-notices.component";
import {StoreModule} from "@ngrx/store";
import * as fromTrunkNotice from "./+state/trunk-notice.reducer";
import {EffectsModule} from "@ngrx/effects";
import {TrunkNoticeEffects} from "./+state/trunk-notice.effects";
import {DataTableModule} from '../data-table/data-table.module';
import {TrunkNoticeDialogComponent} from "./trunk-notice-dialog/trunk-notice-dialog.component";
import {MatInputModule} from "@angular/material/input";
import {ReactiveFormsModule} from "@angular/forms";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";

@NgModule({
  declarations: [
    TrunkNoticesComponent,
    TrunkNoticeDialogComponent
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromTrunkNotice.TRUNK_NOTICE_FEATURE_KEY, fromTrunkNotice.reducer),
    EffectsModule.forFeature([TrunkNoticeEffects]),
    DataTableModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule
  ],
    exports: [
        TrunkNoticesComponent
    ]
})
export class TrunkNoticesModule {}
